import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { TARA_ALL_ACTIVATED_ITEMS_API } from '../../../constants/central-api';

export type ActivatedItem =
  | {
      id: number | string;
      type: 'insight';
      name: string;
      short_code: string;
      placeholder?: string;
      description?: string | null;
      mcp?: string;
      mcp_mapping?: string;
      tara_mcp_slug?: string;
      metric_key?: string;
      is_active: boolean;
      is_activated: boolean;
      shop_config?: { frequency?: string | null; monitoring_enabled?: boolean };
      added_at?: string | null;
    }
  | {
      id: string; // UUID
      type: 'graph';
      name: string;
      short_code: string;
      placeholder?: string;
      is_active: boolean;
      is_notification: boolean;
      added_at?: string | null;
      shop_id?: number;
    }
  | {
      id: string; // UUID
      type: 'prompt';
      name: string;
      short_code: string;
      placeholder?: string;
      content?: string;
      is_active: boolean;
      is_notification: boolean;
      added_at?: string | null;
      shop_id?: number;
    };

export default async function get_all_activated_notification_items_api_call(): Promise<{
  items: ActivatedItem[];
  counts: { insights: number; prompts: number; graphs: number; total: number };
} | null> {
  const shop_slug = store.getState().user.company.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  const sellerToken = isWhiteLabel
    ? accessToken?.currentWhiteLabelSellerToken
    : accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: TARA_ALL_ACTIVATED_ITEMS_API(shop_slug),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_TARA_ALL_ACTIVATED_NOTIFICATION_ITEMS';
  const customMsg = 'All activated items fetched.';
  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res.actionType === actionType && response?.success === true) {
    const data = response?.data;
    return {
      items: Array.isArray(data?.items) ? data.items : [],
      counts: {
        insights: data?.insights_count ?? 0,
        prompts: data?.prompts_count ?? 0,
        graphs: data?.graphs_count ?? 0,
        total: data?.total_items ?? 0,
      },
    };
  }
  return null;
}
